import resolvePath from 'utils/resolvePath';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getUniqueValues = <T extends Record<string, any>>(values: T[], key?: string): T[] => [
  ...new Map(values.map((item) => [resolvePath(item, key), item])).values(),
];

export default getUniqueValues;
